import { useSettings } from "@/contexts/SettingsContext";
import { Truck, Wrench, HardHat } from "lucide-react";
import { COMPANY } from "@/lib/api";

const ASSET_BASE = "https://customer-assets.emergentagent.com/job_coldair-solutions-1/artifacts";
// Supporting fleet/on-site photos so the section never shows empty placeholders.
const ON_SITE_PHOTO = `${ASSET_BASE}/essv5c0c_IMG_0247.jpg`;   // Rooftop condenser hoist — real install
const CREW_PHOTO = `${ASSET_BASE}/yctjc6y8_IMG_0237.jpg`;     // Commercial crew on-site

export default function TruckShowcase() {
  const { settings } = useSettings();
  const trucks = settings.trucks || [];

  const slots = [
    {
      src: trucks[0] || null,
      label: "Service Truck",
      caption: "Fully stocked AIR-COLD HVAC service van — ready to roll across the SGV.",
      icon: Truck,
    },
    {
      src: ON_SITE_PHOTO,
      label: "On-Site Install",
      caption: "Our techs handle every install with precision — no shortcuts, ever.",
      icon: Wrench,
    },
    {
      src: CREW_PHOTO,
      label: "Crew at Work",
      caption: "Trained, uniformed, and licensed crew on every commercial and residential job.",
      icon: HardHat,
    },
  ];

  return (
    <section className="py-12 md:py-20" data-testid="truck-showcase">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="text-xs font-bold uppercase tracking-[0.22em] text-ice-400">Our Fleet</div>
        <h2 className="mt-3 font-display text-3xl md:text-4xl font-black max-w-3xl">FAST. RELIABLE REPAIRS & INSTALLATIONS.</h2>
        <p className="mt-3 text-silver-300 max-w-xl">When you see an AIR-COLD HVAC truck pull up, you know help is here.</p>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {slots.map((slot, i) => {
            const Icon = slot.icon;
            return (
              <div key={i} className="card-ink rounded-2xl overflow-hidden" data-testid={`fleet-slot-${i}`}>
                <div className="aspect-[4/3] bg-ink-700 relative overflow-hidden">
                  {slot.src ? (
                    <>
                      <img src={slot.src} alt={`AIR-COLD HVAC — ${slot.label}`} className="w-full h-full object-cover"/>
                      <div className="absolute inset-0 bg-gradient-to-t from-ink-900/85 via-transparent to-transparent pointer-events-none"/>
                      <div className="absolute bottom-3 left-4 right-4 flex items-center justify-between">
                        <span className="text-xs uppercase tracking-[0.2em] text-ice-400 font-semibold flex items-center gap-1.5">
                          <Icon className="size-3.5"/> {slot.label}
                        </span>
                        <span className="text-[10px] text-silver-200">{COMPANY.phone}</span>
                      </div>
                    </>
                  ) : (
                    <div className="absolute inset-0 grid place-items-center text-center text-silver-500 text-xs uppercase tracking-[0.2em] flex flex-col items-center gap-2 px-6" data-testid={`fleet-placeholder-${i}`}>
                      <Icon className="size-8 text-ice-400/70"/>
                      <span>{slot.label}</span>
                    </div>
                  )}
                </div>
                <div className="p-4">
                  <p className="text-sm text-silver-300">{slot.caption}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
